var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 22,
    height: 11,
    rx: 1,
    fill: "#475569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61597 13.584C8.61597 13.8313 8.55763 14.0647 8.44096 14.284C8.3243 14.5033 8.13763 14.683 7.88097 14.823C7.6243 14.9583 7.2953 15.026 6.89397 15.026H6.01196V17H5.21396V12.135H6.89397C7.2673 12.135 7.5823 12.2003 7.83896 12.331C8.1003 12.457 8.29397 12.6297 8.41997 12.849C8.55063 13.0683 8.61597 13.3133 8.61597 13.584ZM6.89397 14.375C7.1973 14.375 7.42363 14.3073 7.57297 14.172C7.7223 14.032 7.79697 13.836 7.79697 13.584C7.79697 13.052 7.49597 12.786 6.89397 12.786H6.01196V14.375H6.89397ZM13.3741 17H12.5761L10.1751 13.367V17H9.37705V12.128H10.1751L12.5761 15.754V12.128H13.3741V17ZM17.943 13.535C17.817 13.2923 17.642 13.1103 17.418 12.989C17.194 12.863 16.935 12.8 16.641 12.8C16.319 12.8 16.032 12.8723 15.78 13.017C15.528 13.1617 15.3296 13.367 15.185 13.633C15.045 13.899 14.975 14.207 14.975 14.557C14.975 14.907 15.045 15.2173 15.185 15.488C15.3296 15.754 15.528 15.9593 15.78 16.104C16.032 16.2487 16.319 16.321 16.641 16.321C17.075 16.321 17.4273 16.1997 17.698 15.957C17.9686 15.7143 18.1343 15.3853 18.195 14.97H16.368V14.333H19.049V14.956C18.9976 15.334 18.8623 15.6817 18.643 15.999C18.4283 16.3163 18.146 16.5707 17.796 16.762C17.4506 16.9487 17.0656 17.042 16.641 17.042C16.1836 17.042 15.766 16.937 15.388 16.727C15.01 16.5123 14.709 16.216 14.485 15.838C14.2656 15.46 14.156 15.033 14.156 14.557C14.156 14.081 14.2656 13.654 14.485 13.276C14.709 12.898 15.01 12.604 15.388 12.394C15.7706 12.1793 16.1883 12.072 16.641 12.072C17.159 12.072 17.6186 12.2003 18.02 12.457C18.426 12.709 18.72 13.0683 18.902 13.535H17.943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.9b139a987d6b135bb4c0a6648888f0be.svg";
export { ForwardRef as ReactComponent };